import get from "lodash.get";
import React, { memo, useContext, useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useHistory } from "react-router";
import CogOutline from "../../../../assets/images/icons/CogOutline";
import HeaderNotificationIcon from "../../../../assets/images/icons/HeaderNotificationIcon";
import { CustomIconStyle } from "../../../../assets/styles/Button";
import SystemContext from "../../../../context/systemContext";
import { useRequest } from "../../../../hooks/useRequest/UseRequest";
import { NotificationCard, Spinner } from "../components";
import useNotificationOutsideHandler from "../hooks/outsideHandler";
import { NotificationStyled } from "./Notification.style";
import { INotification, INotificationData } from "./Notifications.types";
import { CustomStyledIconButton } from "../../../../styles/global.style";

const Notification = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [page, setPage] = useState(1);
  const [newNotificationLength, setNewNotificationLength] = useState("");
  const notificationContentRef = useRef<HTMLDivElement>(null);
  useNotificationOutsideHandler(notificationContentRef, setOpen);
  const [data, setData] = useState<INotificationData>({
    notificationList: [],
    notificationListTotal: 0,
  });

  const history = useHistory();

  const {
    getNotifications,
    notificationPlay,
    notification,
    notificationLength,
  } = useContext<any>(SystemContext);

  const [
    seenNoteClient,
    seenNoteData,
    seenNoteStatus,
    seenNoteError,
  ] = useRequest();

  useEffect(() => {
    updateData();
  }, []);

  const updateData = async () => {
    const newData: INotificationData = await getNotifications(page);
    setData(newData);
  };

  const getMoreNotification = async () => {
    setPage((prev) => prev + 1);
    const newData: INotificationData = await getNotifications(page + 1);
    setData(({ notificationList }) => {
      return {
        notificationList: notificationList?.concat(newData?.notificationList),
        notificationListTotal: newData?.notificationListTotal || 0,
      };
    });
  };

  useEffect(() => {
    if (!notificationLength) setNewNotificationLength("");
    else if (notificationLength <= 99)
      setNewNotificationLength(notificationLength?.toString());
    else setNewNotificationLength("+99");
  }, [notificationLength]);

  const notificationIconClick = () => {
    setOpen((prev) => !prev);
  };

  const notificationCardClick = (notification: INotification): void => {
    seenNoteClient.post("seen-note", { notificationId: notification._id });
    console.log(notification);
    if (notification.type === "taskDeadline") {
      return history.push({
        pathname: `/tasks/list`,
        state: { taskId: notification?.employeeTaskId },
      });
    } else
      history.push(`/group/groups/details/${get(notification, "group._id")}`);
  };

  return (
    <NotificationStyled
      onClick={notificationIconClick}
      ref={notificationContentRef}
    >
      <CustomStyledIconButton className="notification-container">
        <HeaderNotificationIcon />
        {notificationLength > 0 && (
          <span className="notification-count">{newNotificationLength}</span>
        )}
      </CustomStyledIconButton>
      <div
        className={`notification-menu ${open ? "open" : "close"}`}
        id="notificationMenu"
        style={{ height: "400px" }}
      >
        <div className="notification-menu-header">
          <p className="notification-menu-header-text">Notifications</p>
          <CustomIconStyle onClick={() => history.push("/notification")}>
            <CogOutline />
          </CustomIconStyle>
        </div>
        <InfiniteScroll
          dataLength={data?.notificationList?.length || 0}
          next={getMoreNotification}
          hasMore={data?.notificationList?.length < data?.notificationListTotal}
          loader={
            <div className="d-flex justify-content-center ">
              <Spinner />
            </div>
          }
          scrollableTarget="notificationMenu"
        >
          {data?.notificationList?.map(
            (notification: INotification, index: number) => {
              return (
                <div
                  className="notification-menu-list-item"
                  key={index}
                  onClick={() => notificationCardClick(notification)}
                >
                  <NotificationCard notification={notification} />
                </div>
              );
            }
          )}
        </InfiniteScroll>
      </div>
    </NotificationStyled>
  );
};

export default memo(Notification);
